import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=bce755ba&scoped=true&"
import script from "./Gateway.vue?vue&type=script&lang=js&"
export * from "./Gateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce755ba",
  null
  
)

export default component.exports